import MarkMatches, { type MarkMatchesProps } from './MarkMatches';

export type { MarkMatchesProps };
export default MarkMatches;
